import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

const CONSENT_KEY = 'cookie_consent';

export function getConsentStatus() {
  return localStorage.getItem(CONSENT_KEY);
}

export function CookieConsent() {
  var { t } = useLanguage();
  var [visible, setVisible] = useState(false);

  useEffect(function () {
    var consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    window.dispatchEvent(new Event('cookie_consent_change'));
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[999] p-4 md:p-6"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-3xl mx-auto glass rounded-lg border border-border p-5 md:p-6 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="hidden sm:block p-2 rounded-md bg-primary/10">
            <Shield className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold mb-1">{t('cookies.title')}</p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {t('cookies.description')}{' '}
              <Link to="/privacy" className="underline hover:text-primary transition-colors">
                {t('cookies.privacyLink')}
              </Link>
            </p>
            <div className="flex flex-wrap gap-3 mt-4">
              <Button
                size="sm"
                onClick={handleAccept}
                className="bg-primary hover:bg-primary/90 text-xs px-6"
                data-testid="cookie-accept-btn"
              >
                {t('cookies.accept')}
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={handleDecline}
                className="text-xs px-6"
                data-testid="cookie-decline-btn"
              >
                {t('cookies.decline')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
